import Utils from './Utils';
const LASTTOUCH_PROFILE_KEY = 'lasttouch.profile';
const LASTTOUCH_FAVORITED_KEY = 'lasttouch.favorited';

export const setProfileLastTouch = value =>
  localStorage.setItem(LASTTOUCH_PROFILE_KEY, value);

export const setProfileLastTouchFavorited = value =>
  localStorage.setItem(LASTTOUCH_FAVORITED_KEY, value);

export const getProfileLastTouch = () =>
  localStorage.getItem(LASTTOUCH_PROFILE_KEY);

export const getProfileLastTouchFavorited = () =>
  localStorage.getItem(LASTTOUCH_FAVORITED_KEY);
